import React, { useState, useEffect, useReducer } from 'react'
import { Col, Panel, Row, IconButton, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import NotificationOfAssetsTable from './NotificationOfAssetsTable'
import NotificationOfAssetsForm from './NotificationOfAssetsForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import notification from '../../../utils/notification'
import {
  deleteNotificationOfAssets,
  editNotificationOfAssets,
  getNotificationOfAssets,
  saveNotificationOfAssets,
} from '../../../redux/actions/notificationOfAssets'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'

export default function NotificationOfAssetsWidget(props) {
  const { useType } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)
  const [selectRowData, setSelectRowData] = useState()
  const [isExpandedForm, setIsExpandedForm] = useState(true)
  const [isAddBankAccount, setIsAddBankAccount] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const projectCode = sessionStorage.getItem('projectCode')
  const [requestBody, setRequestBody] = useState()
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    setTableData(formSchema?.result?.values || [])
  }, [formSchema])

  const handleGetSchemaEdit = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await editNotificationOfAssets(id, useType)
      console.log('ressss ', response)
      setSelectRowData(response?.model?.result?.values[0] || null)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSelectRowData = async (rowData) => {
    setIsAddBankAccount(false)
    setIsExpanded(false)
    handleGetSchemaEdit(rowData.id)
  }

  const handleAddBankAccount = () => {
    clearErrors()
    setIsAddBankAccount(true)
    setIsExpanded(false)
  }

  const onSubmit = (data) => {
    console.log('data ', data)
    let request = {
      id: selectRowData?.id ? selectRowData.id : null,
      // projectCode: projectCode,
      notificationMessage: data.notificationMessage,
      activeStatus: data.activeStatus,
      activeRole: data.usersRole || [],
      notificationStartDate: data?.notificationStartDate
        ? data?.notificationStartDate.toLocaleString()
        : '',
      notificationStopDate: data?.notificationStopDate
        ? data?.notificationStopDate.toLocaleString()
        : '',
      startDateCounting: data?.startDateCounting ? data?.startDateCounting.toLocaleString() : '',
      stopDateCounting: data?.stopDateCounting ? data?.stopDateCounting.toLocaleString() : '',
      // notiType: useType == 1 ? useType : data.notiType,
      notiType: useType,
    }
    setRequestBody(request)
    setIsShowConfirm(true)
  }

  const handleCallService = async (requestBody) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)

    try {
      let response = await saveNotificationOfAssets(requestBody)
      if (response) {
        // clearValues()

        setIsExpanded(true)
        setIsAddBankAccount(false)
        setSelectRowData()
        // setFormSchema(response.model)
        setIsShowConfirm(false)
        handleOnReload()
      } else {
        // setIsError('ไม่สำเร็จ')
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnReload = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getNotificationOfAssets('', useType)
      if (response) {
        // setSchema(response)
        setFormSchema(response.model)
      }
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnDelete = async (rowData) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)
    try {
      const response = await deleteNotificationOfAssets(rowData.id)
      if (response == 200) {
        handleOnReload(projectCode)
      } else {
        alert('test')
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.statusText || 'ลบไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={formSchema.header}
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        <NotificationOfAssetsTable
          // data={tableData}
          data={formSchema?.result?.values || []}
          loading={isLoading}
          onSelect={handleSelectRowData}
          onDelete={handleOnDelete}
          isViewMode={formSchema?.disabled}
          useType={useType}
        />

        {!formSchema?.disabled && (
          <IconButton
            appearance="primary"
            icon={<Icon icon="plus" />}
            onClick={() => {
              handleAddBankAccount()
            }}
            //size="sm"
            style={{ float: 'right', marginTop: 10, marginBottom: 10 }}
          >
            เพิ่มรายการแจ้งเตือน
          </IconButton>
        )}
      </Panel>

      <br />

      {(isAddBankAccount || selectRowData) && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={isAddBankAccount ? 'เพิ่มรายการแจ้งเตือน' : 'แก้ไข'}
          bordered
          expanded={isExpandedForm}
          onSelect={() => {
            setIsExpandedForm(!isExpandedForm)
          }}
        >
          <NotificationOfAssetsForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            getValues={getValues}
            rowData={selectRowData}
            isAddBankAccount={isAddBankAccount}
            useType={useType}
          />

          <hr />

          {isError && <Message showIcon type="error" description={isError} />}

          <Row>
            <Col style={{ textAlign: 'end' }}>
              <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>

              <CancelButton
                onClick={() => {
                  setIsExpanded(true)
                  setIsAddBankAccount(false)
                  setSelectRowData()
                  clearErrors()
                }}
              >
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </Panel>
      )}

      <ConfirmWidget
        title={`ยืนยันการบันทึก`}
        show={isShowConfirm}
        // detail={`กรุณายืนยันบันทึก`}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={() => handleCallService(requestBody)}
      />

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  )
}
